import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { type KeyLeverPriority, keyLeversStrings } from './keyLevers.content';
import { type KeyLeverSection, leverLinksFor } from './keyLevers.utils';

type KeyLeversAgentContext = Readonly<{
  gradeLabel: string;
  priority: KeyLeverPriority;
  sections: readonly KeyLeverSection[];
}>;

export const useAgentContext = ({ gradeLabel, priority, sections }: KeyLeversAgentContext) => {
  useRegisterAgentContext({
    kind: 'section',
    title: keyLeversStrings.title,
    description: keyLeversStrings.subtitle,
    detail:
      'Coaches pick a student grade, then a priority tab (Primary, Secondary, Tertiary, Conditional) to see which levers to reach for at that grade, grouped by unlock. Each lever has a directive, a "Why this matters" rationale, and links to related guides, competencies, and tools.',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `${priority} key levers for a student in ${gradeLabel}`,
    data: {
      grade: gradeLabel,
      priority,
      sections: sections.map((section) => ({
        title: section.title,
        levers: section.levers.map((lever) => ({
          name: lever.name,
          directive: lever.directive,
          whyThisMatters: lever.rationale,
          links: leverLinksFor(lever),
        })),
      })),
    },
  });
};
